import React, { useEffect, useRef } from 'react';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.css';

interface VectorMapProps {
    id?: string;
    height?: number;
    width?: string;
    options?: any;
}

const VectorMap: React.FC<VectorMapProps> = ({ id = 'map', height = 300, width = '100%', options = {} }) => {
    const mapRef = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<any>(null);

    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.innerHTML = '';
        }

        if (mapRef.current && !mapInstance.current) {
            // Default options
            const defaultOptions = {
                selector: mapRef.current,
                map: 'world',
                visualizeData: {
                    scale: ['#f1eff7', '#471ca8'],
                    values: {
                        US: 55,
                        CA: 25,
                        GB: 15,
                        RU: 10,
                        CN: 5,
                        IN: 5,
                        BR: 5,
                        AU: 5,
                        ZA: 10,
                        DE: 5,
                        FR: 5,
                        IT: 15,
                        ES: 25,
                        JP: 5,
                        KR: 5,
                        ID: 35,
                        TR: 5,
                        SA: 25,
                        MX: 5,
                        AR: 5,
                        EG: 18,
                        NG: 5,
                        KE: 5,
                        TH: 17,
                        VN: 5,
                        MY: 5,
                        PH: 11,
                        SG: 5,
                        NZ: 10,
                        AE: 5,
                        QA: 5,
                        KW: 5,
                        OM: 5,
                        BH: 4,
                        JO: 5,
                        LB: 5,
                        IL: 15,
                        GR: 5,
                        PT: 18,
                        SE: 5,
                        NO: 5,
                        FI: 5,
                        DK: 4,
                        NL: 5,
                        BE: 5,
                        CH: 1,
                        AT: 5,
                        PL: 5,
                        CZ: 5,
                        HU: 5,
                        RO: 28,
                        BG: 5,
                        RS: 5,
                        HR: 5,
                        SI: 5,
                        SK: 5,
                        UA: 5,
                        BY: 5,
                        KZ: 5,
                        UZ: 5,
                        TM: 5,
                        AZ: 5,
                        GE: 5,
                        AM: 5,
                        MD: 5,
                        LT: 5,
                        LV: 5,
                        EE: 5,
                        IE: 5,
                        IS: 5,
                        CY: 5,
                        MT: 5,
                        LU: 5,
                        LI: 5,
                        MC: 5,
                        SM: 5,
                        VA: 5,
                        AD: 5,
                        BA: 5,
                        MK: 5,
                        AL: 5,
                        ME: 5,
                        XK: 5,
                    }
                },
                zoomButtons: false,
                zoomOnScroll: false,
                regionStyle: {
                    initial: {
                        fill: 'rgba(71, 28, 168, 0.15)'
                    },
                    selected: {
                        fill: 'rgba(71, 28, 168, 0.35)'
                    }
                },
                ...options
            };

            mapInstance.current = new jsVectorMap(defaultOptions);
        }

        return () => {
            if (mapInstance.current) {
                mapInstance.current = null;
            }
            if (mapRef.current) {
                mapRef.current.innerHTML = '';
            }
        };
    }, [options]);

    return <div id={id} ref={mapRef} style={{ width: width, height: height }} />;
};

export default VectorMap;
